module.exports = __webpack_public_path__ + "static/img/preview.5f8d953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/land-rover/preview.jpg
// module id = 3XUE
// module chunks = 1